import { TimeSlotType } from 'shared-types/SpaPackage';

import { OptionRef } from './timeslotClash';

type GuestSelection = OptionRef & {
  isSelected: boolean;
  timeslot?: { startTime: string } | null;
};

type Guest = {
  configurationGroups?:
    | Record<string, (GuestSelection | null | undefined)[] | undefined>
    | undefined;
};

const slotKey = ({ configurationGroupId, optionId }: OptionRef, startTime: string) =>
  `${configurationGroupId}:${optionId}:${startTime}`;

export function countStartTimesHeldByOtherGuests(
  guests: (Guest | null | undefined)[] | undefined,
  guestIndex: number
): Map<string, number> {
  const held = new Map<string, number>();

  (guests ?? []).forEach((guest, index) => {
    if (index === guestIndex) return;

    Object.values(guest?.configurationGroups ?? {}).forEach((selections) => {
      (selections ?? []).forEach((selection) => {
        if (!selection?.isSelected || !selection.timeslot) return;

        const key = slotKey(selection, selection.timeslot.startTime);

        held.set(key, (held.get(key) ?? 0) + 1);
      });
    });
  });

  return held;
}

export function isStartTimeAtCapacity(
  heldByOtherGuests: Map<string, number>,
  option: OptionRef,
  timeslot: Pick<TimeSlotType, 'startTime'> & Partial<Pick<TimeSlotType, 'quantity'>>
): boolean {
  const spaces = timeslot.quantity;

  if (spaces === null || spaces === undefined) return false;

  return (heldByOtherGuests.get(slotKey(option, timeslot.startTime)) ?? 0) >= spaces;
}
